<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { concat } from "lodash";

export default {
  mixins: [fandomBasicMixin],
  data: function () {
    return {
      ranking: null,
      hasMore: false,
      page: 1
    };
  },
  mounted() {
    this.getRanking(this.page);
  },
  methods: {
    getRanking(page, appendRanking = false) {
      Fandom.ajax({
        method: "GET",
        data: { ranking_name: this.content.ranking_name, page: page },
        url: "/api/v5/vote_ranking",
        success: (data) => {
          if (appendRanking) {
            this.ranking = concat(this.ranking, data.ranking);
          } else {
            this.ranking = data.ranking;
          }
          this.hasMore = data.has_more;
          this.page = page;
        }
      });
    }
  }
};
</script>

<template>
  <div v-if="ranking" vote-ranking-component>
    <!-- margin management -->
    <div class="container py-5 my-lg-5">
      <div class="row justify-content-center text-black">
        <div class="col-12 col-lg-10 col-xl-8 px-0 px-sm-3">
          <div class="mb-5 px-3">
            <div v-if="content.title" v-html="content.title"></div>
            <div v-if="content.description" v-html="content.description"></div>
          </div>
          <div class="row border-bottom border-black pb-2 mb-2 mx-2 mx-sm-0">
            <div class="col-12 d-flex justify-content-between font-sm">
              <div class="text-uppercase">{{ft("globals.user")}}</div>
              <div class="mw-label text-center text-uppercase">{{ft("globals.votes")}}</div>
            </div>
          </div>
          <ranking-vote-entry class="border-bottom" :entry="entry" v-for="(entry, index) in ranking" :index="index" :key="index"></ranking-vote-entry>
          <div class="row pt-4" v-if="hasMore">
            <div class="col-12"></div>
            <div class="col-sm-12 text-center">
              <button class="btn" :class="getPrimaryButtonClass(content.button_class)" @click="getRanking((page + 1), true)">{{ft("globals.load_more")}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- margin management -->
  <div v-else vote-ranking-component>
    <div class="container my-5">
      <div class="row justify-content-center">
        <div class="col-sm-10">
          <div class="mb-3">
            <div v-if="content.title" v-html="content.title"></div>
            <p class="mb-0">{{ft("ranking.empty")}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[vote-ranking-component] {

  .mw-label {
    min-width: 5rem;
  }

  @include media-breakpoint-down(xs) {
    .mw-label {
      min-width: 4rem;
    }
  }

}
</style>
